import React from 'react';
import { Text } from '@fluentui/react';
import { Link } from 'react-router-dom';
import { changeDateFormat, getParagraphFromContent } from 'app/components/helpers';
import DOMPurify from 'dompurify';

import './SearchSuggestion.scss';
import { SuggestDocument, Tag } from 'generated/search-backend';
interface ISearchProps {
    listData: SuggestDocument;
    onClick?: () => void;
}

const SearchSuggestion: React.FC<ISearchProps> = (props) => {
    const { listData, onClick } = props; // TODO: Add onClick functionality later

    return (
        <>
            <div className="search-results-links">
                <Text>
                    <Link role="link" to={`/news-feed/article/${listData.id}`} onClick={onClick}>
                        {listData.title}
                    </Link>
                </Text>

                <p
                    className="search-results-description"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(getParagraphFromContent(listData.content))
                    }}></p>

                <div className="tags-container">
                    <Text>
                        <span className="result-date"> {changeDateFormat(listData.createdOn, 'MMMM DD, YYYY')}</span>
                    </Text>
                    {listData.tags[0] && (
                        <div>
                            {listData.tags.map((item: Tag, index: number) => (
                                <span className="result-type" aria-label={item?.displayName} key={index} tabIndex={0}>
                                    <span className="type-icon"></span> {item?.displayName}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default SearchSuggestion;
